export const trainingConstants = {
    TRAINING_LIST_SUCCESS: 'TRAINING_LIST_SUCCESS',
    TRAINING_LIST_FAILURE: 'TRAINING_LIST_FAILURE',

    MY_TRAINING_SUCCESS : 'MY_TRAINING_SUCCESS',
    MY_TRAINING_FAILURE : 'MY_TRAINING_FAILURE',

    TEAM_TRAINING_SUCCESS : 'TEAM_TRAINING_SUCCESS',
    TEAM_TRAINING_FAILURE : 'TEAM_TRAINING_FAILURE',

    TRAINING_DETAILS_SUCCESS : "TRAINING_DETAILS_SUCCESS",
    TRAINING_DETAILS_FAILURE : "TRAINING_DETAILS_FAILURE",

    ONGOING_TRAINING_SUCCESS : "ONGOING_TRAINING_SUCCESS",
    ONGOING_TRAINING_FAILURE : "ONGOING_TRAINING_FAILURE",

    EXTERNAL_TRAINING_LIST_SUCCESS : "EXTERNAL_TRAINING_LIST_SUCCESS",
    EXTERNAL_TRAINING_LIST_FAILURE : "EXTERNAL_TRAINING_LIST_FAILURE",

    ALL_EXTERNAL_TRAINING_SUCCESS : "ALL_EXTERNAL_TRAINING_SUCCESS",
    ALL_EXTERNAL_TRAINING_FAILURE : "ALL_EXTERNAL_TRAINING_FAILURE"
}